import { Component, OnInit, ChangeDetectorRef, AfterViewInit, Injectable } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';

import { ActivatedRoute, Router } from '@angular/router';
import { DialogService } from 'ng2-bootstrap-modal';
import { AuthWebService } from '../services/authweb.service'
import { UtilityServiceService } from '../services/utility-service.service';
import { environment } from 'environments/environment';
import { CarrierService } from "../services/carrier.service";
import { Account } from 'app/constants/account.enum';
import { AlertComponent } from 'app/popup/alert.component';
import { CountryService } from 'app/services/country.service';
import { CarrierTypeService } from 'app/services/carrier-type.service';
import { TransportAssocService } from 'app/services/transport-assoc.service';
import { isNumeric } from 'rxjs/util/isNumeric';
import { concat } from 'rxjs';
import { SearchCountryField, TooltipLabel, CountryISO } from 'app/shared/projects/ngx-intl-tel-input/src/public_api';
import { GooglePlacesSearchService } from 'app/services/google-places-search.service';
import { PopupService } from 'app/services/shared/popup.service';
import {NgbCalendar, NgbDateAdapter, NgbDateParserFormatter, NgbDateStruct, NgbActiveModal, NgbModal, NgbModalRef} from '@ng-bootstrap/ng-bootstrap';
import { DatePipe } from '@angular/common';
import * as moment from 'moment';
import { ConfirmDialogService } from 'app/services/shared/confirm-dialog/confirm-dialog.service';
import { debug } from 'console';

/**
 * This Service handles how the date is represented in scripts i.e. ngModel.
 */
@Injectable()
export class CustomAdapter extends NgbDateAdapter<string> {

  readonly DELIMITER = '/';

  fromModel(value: string | null): NgbDateStruct | null {
    if (value) {
      let date = value.split(this.DELIMITER);
      return {
        day : parseInt(date[0], 10),
        month : parseInt(date[1], 10),
        year : parseInt(date[2], 10)
      };
    }
    return null;
  }

  toModel(date: NgbDateStruct | null): string | null {
    return date ? date.day + this.DELIMITER + date.month + this.DELIMITER + date.year : null;
  }
}

/**
 * This Service handles how the date is rendered and parsed from keyboard i.e. in the bound input field.
 */
@Injectable()
export class CustomDateParserFormatter extends NgbDateParserFormatter {

  readonly DT_FORMAT = 'DD/MM/YYYY';

    parse(value: string): NgbDateStruct {
        if (value) {
            value = value.trim();
            let mdt = moment(value, this.DT_FORMAT)
        }
        return null;
    }
    format(date: NgbDateStruct): string {
        if (!date) return '';
        let mdt = moment([date.year, date.month - 1, date.day]);
        if (!mdt.isValid()) return '';
        return mdt.format(this.DT_FORMAT);
    }
}

declare var $;

@Component({
  selector: 'companydetails',
  templateUrl: './companydetails.component.html',
  styleUrls: ['./companydetails.component.css'],
  providers: [
    {provide: NgbDateAdapter, useClass: CustomAdapter},
    {provide: NgbDateParserFormatter, useClass: CustomDateParserFormatter},
    NgbActiveModal,
  ]
})

export class CompanydetailsComponent implements OnInit {
  aCarrier: any = {};
  entityType: any;
  form: UntypedFormGroup;
  isDup = false;
  isEdit: boolean;
  isBasicContactInfo: boolean = true;
  public isLoading = false;
  message = "Loading, please wait...";
  lblHeading: string = "Company Details";
  acc = Account;
  carrierType = 0;
  carrierStatus = 0;
  idType: any;
  whichIdType = 0;
  whichCarrierType = 0
  ddlCountries = [];
  ddlCarrierTypes = [];
  listAssoc: any = [];
  user: any = {};
  status_id: any;
  hasPerson: boolean = false;
  nextCtrl: boolean = false;
  citizen: any = { dob: new Date(), gender: "" };
  isForeignId: boolean = false;
  importCarrier: string = 'false';
   // idTypes = [{ key: 0, value: 'Unknown required Identification' }, { key: 1, value: 'Local ID Number' }, { key: 2, value: 'Foreign Passport/ID Number' }, { key: 3, value: 'Company Registration Number' }, { key: 4, value: 'NPO Registration Number' }, { key: 5, value: 'Trust Number' }];
  idTypes = [{ key: 0, value: 'Unknown' },
             { key: 1, value: 'ID Number' },
             { key: 2, value: 'Foreign Passport / ID Number' },
             { key: 3, value: 'Company Registration Number' },
             { key: 4, value: 'NPO Number' },
             { key: 5, value: '(key 5)' },
             { key: 6, value: 'Closed Corporation Reg No'},
             { key: 7, value: 'Trust Registration No'},
             { key: 8, value: 'ID Number of Main Partner'},
            ];
  trspassoc = "Select Transport Association (Taxi/Bus)";
  originalAccount = { account: {} };
  displayDemographics: boolean = false;
  doSubmit : boolean = false;
  bbbees = [{ text: 'Level 1' },
            { text: 'Level 2' },
            { text: 'Level 3' },
            { text: 'Level 4' },
            { text: 'Level 5' },
            { text: 'Level 6' },
            { text: 'Level 7' },
            { text: 'Level 8' },
            { text: 'NonCompliant' }
            ];
  turnovers = [{ text: 'Less than R 1 Millon' },
               { text: 'Between R 1 Millon and R 5 Million' },
               { text: 'Above R 5 Million' },
              ]
  numberisvalid: boolean;
  is_local_carrier: boolean = false;
  id_type_required_ind = 0;
  is_individual: boolean = false;
  id_label = 'Identification#';

  //SADC Countries
  separateDialCode = true;
  SearchCountryField = SearchCountryField;
  TooltipLabel = TooltipLabel;
  CountryISO = CountryISO;
  defaultCarrierOfficePhone: any = CountryISO.SouthAfrica;
  defaultCarrierCellphone: any = CountryISO.SouthAfrica;
  defaultContactMobile: any = CountryISO.SouthAfrica;
  trn_issue_date: any;
  work_permit_expiry_date: any;
  passport_expiry_date: any;
  bbbee_certficate_date: any;

  //places from google
  placesPredictions: any = [];
  isPlacesPredictionVible = false;
  placesPostalPredictions: any = [];
  isPostalPlacesPredictionVible = false;

  errorField: any = {
      carrier_id: ''
    , carrier_type: 'Customer Type is required'
    , carrier_type_id: 'Customer Type is required'
    , country_id: 'Country is required'
    , registered_name: 'Registered Name is required'
    , trading_name: 'Trading Name is required'
    , sameAsloggeIn: ''
    , first_name: '* First Name is required'
    , last_name: '* Last Name is required'
    , freight_passenger_ind: 'Type of Carrier is required'
    // , registration_number:  (this.id_type_required_ind==6) ? 'Closed Corporation Registration Number is required' : (this.id_type_required_ind==7) ? 'Trust Number is required' : (this.id_type_required_ind==8) ? 'Partner ID is required' : 'Company Registration Number is required'
    //, registration_number: 'Number is required'
    , registration_number: (this.id_type_required_ind != 0) ? 'Number A is required' + this.id_type_required_ind : ''
    //, id_number: 'Number is required'
    , id_number: (this.id_type_required_ind != 0) ? 'Number B is required' : ''
    // , business_type_id: 'Bussiness Type Is required'
    , traffic_register_number: 'Traffic Register Number (TRN) is required'
    , trn_issue_date: "TRN's date-of-issue is required"
    , work_permit_number: 'Work Permit Reference Number is required'
    , work_permit_expiry_date: 'Work Permit Expiry Date is required'
    , id_country_id: 'Country-of-issue is required'
    , passport_expiry_date: 'Passport Expiry Date is required'
    , Contact_CompanyEmail: 'Office Email is required'
    , officePhone: 'Office Phone is required'
    , cellphone: 'Mobile is required'
    , id_type_ind: ''
    , role_served_ind: ''
    // , is_active_person: new FormControl(true)
    // , date_of_birth: new FormControl()
    // , date_created: new FormControl(new Date())
    // , date_modified: new FormControl(new Date())
    // , user_created: new FormControl(this.user.LastName)
    // , user_modified: new FormControl(this.user.LastName)
    // , user_id: new FormControl(this.user.Id)
    // , status_id: new FormControl(this.status_id)
    // , loggedInUser: new FormControl({ first_name: this.user.FirstName, last_name: this.user.LastName, email: this.user.EmailAddress, mobile: this.user.MobileNumber })
    // , copyPhysical_address: 'Physical Address is required'

    // Contact details
    // , PersonId: new FormControl('')
    // , Contact_CarrierID: new FormControl('')
    // , Contact_is_active: new FormControl()
    , Contact_FirstName: "* Contact's First Name is required"
    , Contact_LastName: "* Contact's Last Name is required"
    , Contact_EmailAddress: "* Contact's Email Address is required"
    , Contact_MobileNumber: "* Contact's Mobile Number is required"
    , Contact_CommunicationPreference: "* Contact's Communication Preference is required"
    , Contact_PhysicalAddress1: '* Physical Address is required'
    // , Contact_PhysicalAddress2: 'Physical Address is required'
    // , Contact_PhysicalAddress3: 'Physical Address is required'
    , Contact_Town: "* Physical Address' Town is required"
    , Contact_PostalCode: "* Physical Address' Postal Code is required"
    , Contact_CountryID: "* Physical Address' Country is required"
    , contactSameAsloggeIn: ''
    // , Contact_FaxNumber: 'Fax Number is required'
    // , Contact_CompanyEmail: new FormControl('', Validators.compose([Validators.pattern(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/)]))
    , Contact_PostalAddress1: '* Postal Address is required'
    // , Contact_PostalAddress2: new FormControl('')
    // , Contact_PostalAddress3: new FormControl('')
    , Contact_pTown: "* Postal Address' Town is required"
    , Contact_pPostalCode: "* Postal Address' Postal Code is required"
    , Contact_pCountry: "* Postal Address' Country is required"
    // , Contact_role_served_ind: ''
    // , Contact_date_role_from: ''
    // , Contact_date_role_to:''
    // , Contact_id_type_ind:''

    // Compliance and Legal
    , tax_number: '* Tax Number is required'
    , assoc_id: '* Transport Association is required'

    // Demographics
    // ,black_ownership: new FormControl('', Validators.compose([Validators.required, Validators.min(0), Validators.max(100)]))
    , bbbee_status: '* BBBEE Status is required'
    , bbbee_certficate_date: '* BBBEE Certificate Expiry Date is required'
    , black_ownership: '* % Black Ownership is required'
    , female_ownership: '* % Female Ownership is required'
    , disability_ownership: '* % Disability Ownership is required'
    , youth_owner: '* % Youth Ownership is required'
    , turnover_band: '* TurnOver band is required'
    , num_employees: '* Number of Employees is required'
  };

  isLocal = false;
  currentDate: any = { day: new Date().getDate(), month: (new Date().getMonth() + 1), year: new Date().getFullYear() }
  personId: any;

  constructor(private carrierService: CarrierService,
    private router: Router, private changeDetect: ChangeDetectorRef,
    private route: ActivatedRoute,
    private countryService: CountryService, private authWebService: AuthWebService,
    private carrierTypeService: CarrierTypeService,
    public utility: UtilityServiceService,
    private transportAssocService: TransportAssocService, private msg: ToastrService,
    private googleSearch: GooglePlacesSearchService,
    private ngbCalendar: NgbCalendar, private dateAdapter: NgbDateAdapter<string>,
    private datePipe:DatePipe,
    private showModal: PopupService,private confirmDialogService: ConfirmDialogService) { }

  ngOnInit() {
    this.isEdit = this.utility.ctrlPages[Account.First].isEdit;
    this.user = (this.authWebService.userData) ? this.authWebService.userData.User : {};
    console.log(this.user);
    this.importCarrier = localStorage.getItem('importCarrier');
    // this.retrieveStatusId();
    if(!this.isEdit){this.retrieveStatusId()};
    this.getPersonId();
    this.listCarrierTypes();
    this.listCountries();
    this.lblHeading = (!this.utility.ctrlPages[Account.First].isEdit) ? "New Carrier Details" : "Edit Carrier Details";
    this.initForm();
    this.listDDL();
    this.onFrmChange();
  }

  getPersonId() {
    this.carrierService.carrierPersonByuserId(this.user.Id).subscribe((result:any) => {
      this.personId = result.person_id;
    });
  }

  // initialize the form's elements + add validations
  initForm() {
    this.form = new UntypedFormGroup({
      // Carrier details
        carrier_id: new UntypedFormControl(-1)
      , carrier_type_id: new UntypedFormControl(this.aCarrier.carrier_type_id, Validators.required)
      , country_id: new UntypedFormControl('', Validators.required)
      , sameAsloggeIn: new UntypedFormControl(false)
      , first_name: new UntypedFormControl(this.aCarrier.first_name, Validators.maxLength(50))
      , last_name: new UntypedFormControl(this.aCarrier.last_name, Validators.maxLength(50))
      , registered_name: new UntypedFormControl(this.aCarrier.registered_name, Validators.compose([Validators.maxLength(100)]))
      , trading_name: new UntypedFormControl(this.aCarrier.trading_name, Validators.maxLength(100))
      , registration_number: new UntypedFormControl(this.aCarrier.registration_number, Validators.maxLength(20))
      , freight_passenger_ind: new UntypedFormControl(this.aCarrier.freight_passenger_ind, Validators.required)
      , id_number: new UntypedFormControl('')
      // , business_type_id: new FormControl(this.aCarrier.business_type_ind, Validators.required)
      , traffic_register_number: new UntypedFormControl('')
      , trn_issue_date: new UntypedFormControl('')
      , work_permit_number: new UntypedFormControl('')
      , work_permit_expiry_date: new UntypedFormControl('')
      , id_country_id: new UntypedFormControl('')
      , passport_expiry_date: new UntypedFormControl('')
      , Contact_CompanyEmail: new UntypedFormControl('', Validators.compose([Validators.pattern(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/)]))
      , officePhone: new UntypedFormControl('')
      , cellphone: new UntypedFormControl('')
      , id_type_ind: new UntypedFormControl(0)
      , role_served_ind: new UntypedFormControl()
      , is_active_person: new UntypedFormControl(true)
      , date_of_birth: new UntypedFormControl()
      , date_created: new UntypedFormControl(new Date())
      , date_modified: new UntypedFormControl(new Date())
      , user_created: new UntypedFormControl(this.user.LastName)
      , user_modified: new UntypedFormControl(this.user.LastName)
      , user_id: new UntypedFormControl(this.user.Id)
      , status_id: new UntypedFormControl(this.status_id)
      , loggedInUser: new UntypedFormControl({ first_name: this.user.FirstName, last_name: this.user.LastName, email: this.user.EmailAddress, mobile: this.user.MobileNumber })

      // Contact details
      , PersonId: new UntypedFormControl('')
      , Contact_CarrierID: new UntypedFormControl('')
      , Contact_is_active: new UntypedFormControl()
      , contactSameAsloggeIn: new UntypedFormControl(false)
      // , Contact_FirstName: new FormControl('', Validators.maxLength(20))
      // , Contact_LastName: new FormControl('', Validators.maxLength(20))
      // , Contact_EmailAddress: new FormControl('', [Validators.pattern('^[_A-Za-z0-9-\\+]+(\\.[_A-Za-z0-9-]+)*@[A-Za-z0-9-]+(\\.[A-Za-z0-9]+)*(\\.[A-Za-z]{2,})$')])
      // , Contact_MobileNumber: new FormControl('')
      , Contact_FirstName: new UntypedFormControl('', [Validators.required , Validators.maxLength(20)])
      , Contact_LastName: new UntypedFormControl('', [Validators.required , Validators.maxLength(20)])
      , Contact_EmailAddress: new UntypedFormControl('', [Validators.required , Validators.pattern('^[_A-Za-z0-9-\\+]+(\\.[_A-Za-z0-9-]+)*@[A-Za-z0-9-]+(\\.[A-Za-z0-9]+)*(\\.[A-Za-z]{2,})$')])
      , Contact_MobileNumber: new UntypedFormControl('',Validators.required)
      , Contact_CommunicationPreference: new UntypedFormControl('',Validators.required)
        , Contact_PhysicalAddress1: new UntypedFormControl('', [Validators.required, Validators.maxLength(40)])
        , Contact_PhysicalAddress2: new UntypedFormControl('', Validators.maxLength(40))
        , Contact_PhysicalAddress3: new UntypedFormControl('', Validators.maxLength(40))
        , Contact_Town: new UntypedFormControl('', [Validators.required, Validators.maxLength(40)])
        , Contact_PostalCode: new UntypedFormControl('', [Validators.required, Validators.maxLength(25)])
      , Contact_CountryID: new UntypedFormControl('', Validators.required)
      , copyPhysical_address: new UntypedFormControl()
        , Contact_PostalAddress1: new UntypedFormControl('', [Validators.required, Validators.maxLength(40)])
        , Contact_PostalAddress2: new UntypedFormControl('', Validators.maxLength(40))
        , Contact_PostalAddress3: new UntypedFormControl('', Validators.maxLength(40))
        , Contact_pTown: new UntypedFormControl('', [Validators.required, Validators.maxLength(40)])
        , Contact_pPostalCode: new UntypedFormControl('', [Validators.required, Validators.maxLength(25)])
      , Contact_pCountry: new UntypedFormControl('', Validators.required)
      , Contact_FaxNumber: new UntypedFormControl('')
      , Contact_role_served_ind: new UntypedFormControl(21)
      , Contact_date_role_from: new UntypedFormControl(new Date())
      , Contact_date_role_to: new UntypedFormControl(new Date())
      , Contact_id_type_ind: new UntypedFormControl(1)

      //Compliance and Legal
      , tax_number: new UntypedFormControl('', Validators.maxLength(10))
      , assoc_id: new UntypedFormControl('')

      //Demographics
      // ,black_ownership: new FormControl('', Validators.compose([Validators.required, Validators.min(0), Validators.max(100)]))
      , bbbee_status: new UntypedFormControl('', Validators.maxLength(12))
      , bbbee_certficate_date: new UntypedFormControl('')
      , black_ownership: new UntypedFormControl('', [Validators.max(100), Validators.min(0)])
      , female_ownership: new UntypedFormControl('', [Validators.max(100), Validators.min(0)])
      , disability_ownership: new UntypedFormControl('', [Validators.max(100), Validators.min(0)])
      , youth_owner: new UntypedFormControl('', [Validators.max(100), Validators.min(0)])
      , turnover_band: new UntypedFormControl('')
      , num_employees: new UntypedFormControl('', [Validators.min(0)])
    });
    this.initFormData();
  }

  // retrieve the carrier account's details (if it exists)
  initFormData = () => {
    if (this.utility.ctrlPages[Account.First].carrierId > 0) {
      this.message = "Loading, please wait...";
      this.isLoading = true;
      this.carrierService.getCompanyDetailsById(this.utility.ctrlPages[Account.First].carrierId).subscribe(result => {
                          this.aCarrier = result;
                          //console.log('Carrier = ', this.aCarrier);
                          this.aCarrier.Contact.EmailAddress = this.aCarrier.Contact.EmailAddress == null ? "" : this.aCarrier.Contact.EmailAddress;
                          this.aCarrier.Carrier.email = this.aCarrier.Carrier.email == null ? "" : this.aCarrier.Carrier.email;
                          this.isLoading = false;
                          this.setFormData();
      }, error => {
        this.isLoading = false;
        this.msg.warning("Carrier Account's details could not be retrieved", "Carrier Account", { timeOut: 3000 });
      });
    } else {
      if (Object.keys(this.aCarrier).length > 0) {
        //console.log(this.aCarrier);
        this.setFormData();
      }
    }
    this.isBasicContactInfo = true;
  }

  ngOnDestroy() {
  }

  // if new or unsubmitted account, allow all changes
  // if submitted account, allow changes to basics without changing the status, otherwise allow changes to core but account then needs to be re-submitted
  // if approved account, allow changes to basic contact information only
    changeBasicContactInfoParm() {
    if(this.status_id != 1){
      return this.isBasicContactInfo = false;
      }
  }

  // populate the form's elements
  setFormData() {
    (<UntypedFormGroup>this.form)
      .setValue({

        // Carrier details
          carrier_id: this.aCarrier.Carrier.carrier_id
        , carrier_type_id: this.aCarrier.Carrier.carrier_type_id
        , country_id: this.aCarrier.Carrier.country_id
        , registered_name: this.aCarrier.Carrier.registered_name
        , trading_name: this.aCarrier.Carrier.trading_name
        , registration_number: this.aCarrier.Carrier.registration_number
        , id_type_ind: this.aCarrier.Carrier.id_type_ind
        , id_country_id: this.aCarrier.Carrier.id_country_id
        , id_number: this.aCarrier.Carrier.registration_number
        , sameAsloggeIn: false             //, sameAsloggeIn: this.aCarrier.Carrier.sameAsloggeIn
        , contactSameAsloggeIn: false      //, contactSameAsloggeIn: this.aCarrier.Carrier.contactSameAsloggeIn
        , role_served_ind: this.aCarrier.Carrier.role_served_ind
        , first_name: this.aCarrier.Carrier.first_name
        , last_name: this.aCarrier.Carrier.last_name
        , is_active_person: this.aCarrier.Carrier.is_active_person
        , date_of_birth: this.aCarrier.Carrier.date_of_birth
        , date_created: this.aCarrier.Carrier.date_created
        , date_modified: new Date()
        , user_created: this.aCarrier.Carrier.user_created
        , user_modified: this.user.LastName
        , user_id: this.aCarrier.Carrier.user_id
        , status_id: this.aCarrier.Carrier.status_id
        , loggedInUser: { first_name: this.user.FirstName, last_name: this.user.LastName, email: this.user.EmailAddress }
        , copyPhysical_address: null     // , copyPhysical_address: this.aCarrier.Carrier.copyPhysical_address
        , traffic_register_number: this.aCarrier.Carrier.traffic_register_number
        , trn_issue_date: this.aCarrier.Carrier.trn_issue_date
        , work_permit_number: this.aCarrier.Carrier.work_permit_number
        , work_permit_expiry_date: this.aCarrier.Carrier.work_permit_expiry_date
        , passport_expiry_date: this.aCarrier.Carrier.passport_expiry_date
        // , business_type_id: this.aCarrier.Carrier.business_type_ind
        , freight_passenger_ind: this.aCarrier.Carrier.freight_passenger_ind
        , officePhone: this.aCarrier.Carrier.telephone
        , cellphone: this.aCarrier.Carrier.cellphone

        //Contact details
        , PersonId: this.aCarrier.Contact.PersonId
        , Contact_CarrierID: this.aCarrier.Carrier.carrier_id
        , Contact_is_active: this.aCarrier.Contact.is_active
        , Contact_FirstName: this.aCarrier.Contact.FirstName
        , Contact_LastName: this.aCarrier.Contact.LastName
        , Contact_EmailAddress: this.aCarrier.Contact.EmailAddress.toLowerCase()
        , Contact_MobileNumber: this.aCarrier.Contact.MobileNumber
        , Contact_CommunicationPreference: this.aCarrier.Carrier.communication_type
        , Contact_PhysicalAddress1: this.aCarrier.Carrier.physical_address_1
        , Contact_PhysicalAddress2: this.aCarrier.Carrier.physical_address_2
        , Contact_PhysicalAddress3: this.aCarrier.Carrier.physical_address_3
        , Contact_Town: this.aCarrier.Carrier.physical_address_town
        , Contact_PostalCode: this.aCarrier.Carrier.physical_post_code
        , Contact_CountryID: this.aCarrier.Carrier.country_id
        , Contact_FaxNumber: this.aCarrier.Carrier.fax
        , Contact_CompanyEmail: this.aCarrier.Carrier.email.toLowerCase()
        , Contact_PostalAddress1: this.aCarrier.Carrier.postal_address_1
        , Contact_PostalAddress2: this.aCarrier.Carrier.postal_address_2
        , Contact_PostalAddress3: this.aCarrier.Carrier.postal_address_3
        , Contact_pTown: this.aCarrier.Carrier.postal_address_town
        , Contact_pPostalCode: this.aCarrier.Carrier.postal_post_code
        , Contact_pCountry: (this.aCarrier.Carrier.country_id > 0) ? this.aCarrier.Carrier.country_id : 21
        , Contact_role_served_ind: this.aCarrier.Contact.role_served_ind
        , Contact_date_role_from: (this.isValidDate(this.aCarrier.Contact.date_role_from)) ? this.aCarrier.Contact.date_role_from : new Date()
        , Contact_date_role_to: (this.isValidDate(this.aCarrier.Contact.date_role_to)) ? this.aCarrier.Contact.date_role_to : new Date()
        , Contact_id_type_ind: this.aCarrier.Contact.id_type_ind

        //Compliance and Legal
        , tax_number: this.aCarrier.Carrier.tax_number
        , assoc_id: (this.aCarrier.Carrier.assoc_id) ? this.aCarrier.Carrier.assoc_id : ""

        //Demographics
        , bbbee_status: this.aCarrier.Carrier.bbbee_status
        , bbbee_certficate_date: this.aCarrier.Demographic.BBBEE_cert_expiry_date
        , black_ownership: this.aCarrier.Demographic.black_ownership_percentage
        , female_ownership: this.aCarrier.Demographic.female_ownership_percentage
        , disability_ownership: this.aCarrier.Demographic.disability_ownership_percentage
        , youth_owner: this.aCarrier.Demographic.youth_ownership_percentage
        , turnover_band: this.aCarrier.Demographic.turnover_band
        , num_employees: this.aCarrier.Demographic.number_of_employees
      }, { onlySelf: true });

    this.defaultCarrierOfficePhone = (this.aCarrier.Carrier.iso2_tele) ? this.aCarrier.Carrier.iso2_tele : CountryISO.SouthAfrica;
    this.defaultCarrierCellphone = (this.aCarrier.Carrier.iso2_cell) ? this.aCarrier.Carrier.iso2_cell : CountryISO.SouthAfrica;
    this.defaultContactMobile = (this.aCarrier.Contact.iso2_cell) ? this.aCarrier.Contact.iso2_cell : CountryISO.SouthAfrica;

    this.bbbee_certficate_date = this.aCarrier.Demographic.BBBEE_cert_expiry_date;

    this.addFields(this.aCarrier.Carrier.id_type_ind);
    this.whichCarrierType = this.aCarrier.carrier_type_id;
    this.carrierType = this.aCarrier.Carrier.carrier_type_id;
    this.idType = this.aCarrier.Carrier.id_type_ind;
    this.id_type_required_ind = this.aCarrier.Carrier.id_type_ind;

    if (this.id_type_required_ind) {
      this.trn_issue_date = this.aCarrier.Carrier.trn_issue_date;
      this.work_permit_expiry_date = this.aCarrier.Carrier.work_permit_expiry_date;
      this.passport_expiry_date = this.aCarrier.Carrier.passport_expiry_date;
      this.trn_issue_date = this.aCarrier.Carrier.trn_issue_date;

      setTimeout(()=>{
        if(this.bbbee_certficate_date!=null){
          let date:any=this.datePipe.transform(this.bbbee_certficate_date,"dd/MM/yyyy");
          this.form.get('bbbee_certficate_date').setValue(date);
          this.form.get('bbbee_certficate_date').setErrors(null);
          //console.log(this.form.value.bbbee_certficate_date);
        }
        if(this.trn_issue_date!=null){
          let date:any=this.datePipe.transform(this.trn_issue_date,"dd/MM/yyyy");
            this.form.get('trn_issue_date').setValue(date);
          this.form.get('trn_issue_date').setErrors(null);
        }
        if(this.work_permit_expiry_date!=null){
          let date:any=this.datePipe.transform(this.work_permit_expiry_date,"dd/MM/yyyy");
            this.form.get('work_permit_expiry_date').setValue(date);
          this.form.get('work_permit_expiry_date').setErrors(null);
        }
        if(this.passport_expiry_date!=null){
          alert(this.passport_expiry_date);
          let date:any=this.datePipe.transform(this.passport_expiry_date,"dd/MM/yyyy");
            this.form.get('passport_expiry_date').setValue(date);
          this.form.get('passport_expiry_date').setErrors(null);
        }
      },800);
    }
    this.onChange('load');
    this.onItemChange();
    this.transient(this.form);
  }

  isValidDate(d: any) {
    return d instanceof Date && !isNaN(d.getTime());
  }

  ChangeCountry(event, key = 1) {
    switch (key) {
      case 1:
        this.defaultCarrierOfficePhone = event.iso2;
        break;
      case 2:
        this.defaultCarrierCellphone = event.iso2;
        break;
      case 3:
        this.defaultContactMobile = event.iso2;
        break;
      default:
        break;
    }
  }

  onSubmit(obj: any, key = 2) {
    if(this.id_type_required_ind==1 || this.id_type_required_ind==2 || this.id_type_required_ind==8){
      // confirm ID is correct - reqd only when one-man-business or partnership
      this.doSubmit = this.preValidateRegNumber('submit');
      this.doSubmit = this.preValidateID('submit');
      //console.log(this.doSubmit);
      if(!this.doSubmit){
        return false;
      }
    }    

    //alert("1!");
    // if(!this.form.valid){
    //   //alert('A14');
    //   this.validateFields(false);
    //   return false;
    // }
    this.isLoading = true;

    this.isEdit = (this.utility.ctrlPages[Account.First].carrierId > 0) ? true : false;
    if (this.whichCarrierType == 1) {
      obj.date_of_birth = (this.id_type_required_ind == 1) ? this.getDOB(obj.id_number) : null;
      obj.registered_name = (this.id_type_required_ind == 1 || this.id_type_required_ind == 2) ? `${obj.last_name}, ${obj.first_name}` : `${this.user.LastName},  ${this.user.FirstName}`;
    }
    if(obj.passport_expiry_date!=null && obj.passport_expiry_date!=''){
      let date:any=new Date(obj.passport_expiry_date.split("/")[2]+"-"+obj.passport_expiry_date.split("/")[1]+"-"+obj.passport_expiry_date.split("/")[0]);
      obj.passport_expiry_date=this.datePipe.transform(date,'yyyy-MM-dd');
    }
    if(obj.work_permit_expiry_date!=null && obj.work_permit_expiry_date!=''){
      let date:any=new Date(obj.work_permit_expiry_date.split("/")[2]+"-"+obj.work_permit_expiry_date.split("/")[1]+"-"+obj.work_permit_expiry_date.split("/")[0]);
      obj.work_permit_expiry_date=this.datePipe.transform(date,'yyyy-MM-dd');
    }
    if(obj.trn_issue_date!=null && obj.trn_issue_date!=''){
      let date:any=new Date(obj.trn_issue_date.split("/")[2]+"-"+obj.trn_issue_date.split("/")[1]+"-"+obj.trn_issue_date.split("/")[0]);
      obj.trn_issue_date=this.datePipe.transform(date,'yyyy-MM-dd');
    }
    if(obj.bbbee_certficate_date!=null && obj.bbbee_certficate_date!=''){
      let date:any=new Date(obj.bbbee_certficate_date.split("/")[2]+"-"+obj.bbbee_certficate_date.split("/")[1]+"-"+obj.bbbee_certficate_date.split("/")[0]);
      obj.bbbee_certficate_date=this.datePipe.transform(date,'yyyy-MM-dd');
    }

    if (this.importCarrier == 'true') {        
      obj.status_id = 1;
      obj.user_id = this.user.Id;
    }

    obj = this.constructCarrierObj(obj);
    this.utility.isChanged = false;

    // write/update carrier details
    if (!this.isEdit) {
      // NEW ACCOUNT -> not yet created -> create
      this.createCACDetails(obj);

    } else {

      // EXISTING ACCOUNT (can have status of 1/2/11/51)...
      this.isLoading = false;

      if(this.carrierStatus == 1) {
        // account is still in 'create' status -> allow all changes
        this.isLoading = true;
        this.updateCACDetails(obj, key);

      } else if(this.carrierStatus == 2){
        // account is in 'Additional Information Required' status -> allow all changes, but reset status
        this.isLoading = true;
        obj.Carrier.status_id = parseInt(this.authWebService.userData.Configurations.find(c => c.Code == "AccountStatus1").Value);
        this.updateCACDetails(obj, key);
      
      } else if(this.carrierStatus == 11) {
        // account was previously submitted, not yet approved...
        if(this.isBasicContactInfo) {
          // changes to basic contact info is allowed
          this.isLoading = true;
          this.updateCACDetails(obj, key);
        } else {
          // changes to core account info -> allowed but will lead to status being reset
            // this.showModal.showYesNo('Save & Continue', 'Please note that the Account will need to be re-submitted for approval. Do you want to continue?', '', 'Yes', 'No')
            //   .subscribe((isConfirmed) => {
            //     if (isConfirmed) {
            //       obj.Carrier.status_id = parseInt(this.authWebService.userData.Configurations.find(c => c.Code == "AccountStatus1").Value);
            //       this.isLoading = true;
            //       this.updateCACDetails(obj, key);
            //     } else {
            //       //this.utility.landingPage();
            //       return
            //     }
            //   });
              this.confirmDialogService.confirmThis('Please note that the Account will need to be re-submitted for approval. Do you want to continue?', () => {  
                obj.Carrier.status_id = parseInt(this.authWebService.userData.Configurations.find(c => c.Code == "AccountStatus1").Value);
                this.isLoading = true;
                this.updateCACDetails(obj, key);

      
              }, () =>  {  
                return
              })
        }

      } else if (this.carrierStatus == 51){
        // account was previously approved...
        // if(this.isBasicContactInfo) {
          // changes to basic contact info is allowed
          this.isLoading = true;
          this.updateCACDetails(obj, key);
        // } else {
        //   // account was approved -> no changes to core account info allowed
        //   this.showModal.showYesNo('Account Changes','Account was approved - No changes other than changes to contact details are allowed.','','OK','Reset')
        //   .subscribe((isConfirmed) => {
        //     if (isConfirmed) {
        //       this.resetForm();
        //     } else {
        //       this.resetForm();
        //     }
        //     this.isLoading = false;
        //     return
        //   });
        // }
      }
      this.isLoading = false;
    }
  }

  addFields = (obj: any = this.idType) => {
    this.isForeignId = (obj != 1) ? true : false;
    switch (obj) {
      case 1:
        this.whichIdType = 1;
        this.addIDValidation();
        break;
      case 2:
        this.whichIdType = 2;
        this.addIDValidation(obj);
        break;
      case 3:
        this.whichIdType = 3;
        this.addIDValidation(obj);
        break;
      default:
        this.whichIdType = 0;
        this.addIDValidation(obj);
        break;
    }
  }

  listCountries = () => {
    this.isLoading = true;
    this.countryService.listCountries().subscribe((result:any) => {
      this.ddlCountries = result;
      this.isLoading = false;
      //console.log(this.ddlCountries);
    }, error => {
      this.isLoading = false;
      //console.log(error);
    });
  }

  listCarrierTypes = () => {
    this.isLoading = true;
    this.carrierTypeService.listCarrierTypes().subscribe((result:any) => {
      this.ddlCarrierTypes = result;
      this.isLoading = false;
    }, error => {
      this.isLoading = false;
      //console.log(error);
    });
  }

  sortBy(prop: string) {
    return this.ddlCarrierTypes.sort((a, b) => a[prop] > b[prop] ? 1 : a[prop] === b[prop] ? 0 : -1);
  }

  retrieveStatusId = () => {
    let status: any;
    if (this.authWebService.userData) {
      status = this.authWebService.userData.Configurations.find(
        config => config.Code == "AccountStatus1").Value;
    }
    this.status_id = status;
  }

  setCarrierPerson = (event: any) => {
    if (event.currentTarget.checked) {
      this.form.patchValue({ first_name: this.user.FirstName, last_name: this.user.LastName });
    } else {
      this.form.patchValue({ first_name: "", last_name: "" });
    }
  }

  updateCACDetails = (obj: any, key = 2) => {
    this.message = "Updating carrier account's company details,please wait...";
    this.isLoading = true;
    this.carrierService.processUpdateCompanyDetails(obj).subscribe(result => {
      this.aCarrier = result;
      this.utility.docCtrl = (this.aCarrier.Carrier.carrier_id > 0) ? true : false;
      this.isLoading = false;
      this.utility.activeTab = key;
      //this.msg.success("Carrier Account's details updated successfully.", "Carrier Account", { timeOut: 1000 });
    }, error => {
      this.isLoading = false;
      this.msg.error("Carrier Account's details could not be updated. Please contact the system administrator if the problem persists."+"\nTel : 012 471 2121'+'\nEmail: helpdesk@cbrta.co.za", "Carrier Account")
    });
  }

  createCACDetails = (obj: any) => {
    this.message = "Creating Carrier Account's details, please wait...";
    this.isLoading = true;
    //alert('3 - breaks on next line');
    this.carrierService.processCompanyDetails(obj).subscribe(result => {
      //alert("6......");
      this.aCarrier = result;
      this.utility.docCtrl = (this.aCarrier.Carrier.carrier_id > 0) ? true : false;
      this.utility.ctrlPages[Account.First].carrierId = this.aCarrier.Carrier.carrier_id;
      this.isLoading = false;
      this.utility.activeTab = 2;
      this.msg.success("Carrier Account's details saved successfully.", "Carrier Account", { timeOut: 1000 });
     }, error => {
       //alert("7!");
       this.isLoading = false;      
       let err: any = JSON.parse(error._body);
       this.msg.error(err.Message +"\n\nCarrier Account's details could not be saved. Please contact the system administrator if the problem persists."+"\nTel : 012 471 2121'+'\nEmail: helpdesk@cbrta.co.za", "Carrier Account")
     });
  }

        requireIDValidation(_isLocal: boolean) {
        let selectedCountryId = this.form.controls.country_id.value;
        if (this.is_local_carrier && selectedCountryId != 113) {
            _isLocal = false;
        }
        return _isLocal;
    }

    preValidateID(source: any) {
    if(this.id_type_required_ind!=1 && this.id_type_required_ind!=2 && this.id_type_required_ind!=8){
      // not reqd when it is a company-type
      return true;
    }

    let idValidationRequired: boolean = this.requireIDValidation(this.isLocal);
    let idNumber:any
    let sourceButton = source;

    if(this.id_type_required_ind==1 || this.id_type_required_ind==2){
      // SA & Foreign individuals/one-man companies
      idNumber = this.form.get('id_number').value;
    } else if (this.id_type_required_ind==8){
      // SA & Foreign partnerships
      idNumber = this.form.get('registration_number').value;
    } else {
      idNumber= null;
      return true;
    }

    if(idNumber=="" || idNumber=='' || idNumber==null && this.carrierType!=1017 && this.carrierType!=1005){
      // exit on empty
      if (this.isLocal && idValidationRequired){
          this.msg.warning("Invalid SA ID Number", "Carrier Account:");
      } else {
          //this.msg.warning("Invalid Passport/ID Number", "Carrier Account:");
      }
        //this.form.get('id_number').markAsDirty();
        //this.form.get('id_number').updateValueAndValidity();
        //this.form.get('registration_number').markAsDirty();
        //this.form.get('registration_number').updateValueAndValidity();    
        //return false; 
    }

    if (this.isLocal && idValidationRequired){
      // SA ID
      // must be numeric
      if(isNaN(+idNumber)){
        this.msg.warning("Invalid SA ID Number - must be numeric!", "Carrier Account:");
        this.form.get('id_number').markAsDirty();
        this.form.get('id_number').updateValueAndValidity();
        this.form.get('registration_number').markAsDirty();
        this.form.get('registration_number').updateValueAndValidity();
        // this.form.controls.carrier_type_id.markAsDirty();
        return false;
      }

      if(idNumber.length === 13){
        // must be 13 chars in length
        // first 6 characters -> must be DOB
        let tempDate = new Date(idNumber.substring(0, 2), (idNumber.substring(2, 4) - 1), idNumber.substring(4, 6));
        let id_date = (tempDate.getDate().toString().length < 2) ? "0" + tempDate.getDate().toString() : tempDate.getDate().toString();
        let id_month = ((tempDate.getMonth() + 1).toString().length < 2) ? "0" + (tempDate.getMonth() + 1).toString() : (tempDate.getMonth() + 1).toString();
        let id_year = tempDate.getFullYear().toString().slice(-2);
        let dob = new Date(id_year + '/' + id_month + '/' + id_date);
        if(!((id_year == idNumber.substring(0, 2).toString()) && (id_month == idNumber.substring(2, 4).toString()) && (id_date == idNumber.substring(4, 6).toString()))) {
          this.msg.warning("Invalid SA ID Number", "Carrier Account:");
          this.form.get('id_number').markAsDirty();
          this.form.get('id_number').updateValueAndValidity();
          this.form.get('registration_number').markAsDirty();
          this.form.get('registration_number').updateValueAndValidity();
          return false;
        }
        // 10th character -> must be 0 (SA born) or 1 (permanent citizen)
        let ind = idNumber.substring(10, 11);
        if(ind != 0 && ind != 1){
          this.msg.warning("Invalid SA ID Number", "Carrier Account:");
          this.form.get('id_number').markAsDirty();
          this.form.get('id_number').updateValueAndValidity();
          this.form.get('registration_number').markAsDirty();
          this.form.get('registration_number').updateValueAndValidity();
          return false;
        }

      } else if (idNumber.length > 13){
        // limit to 13 characters
        this.msg.warning("Invalid SA ID Number - only 13 characters allowed", "Carrier Account:");
        // this.form.patchValue({id_number: idNumber.substring(0,13)});
        this.form.get('id_number').markAsDirty();
        this.form.get('id_number').updateValueAndValidity();
        this.form.get('registration_number').markAsDirty();
        this.form.get('registration_number').updateValueAndValidity();
        return false;        
      } else if (idNumber.length < 13 && sourceButton=="submit"){
        // onSubmit check
        this.msg.warning("Invalid SA ID Number", "Carrier Account:");
        this.form.get('id_number').markAsDirty();
        this.form.get('id_number').updateValueAndValidity();
        this.form.get('registration_number').markAsDirty();
        this.form.get('registration_number').updateValueAndValidity();
        return false; 
      }

    } else {
      if (idNumber.length > 20){
        // limit to 15 characters
        this.msg.warning("Foreign Passport / ID Numbers limited to 20 characters", "Carrier Account:");
        // this.form.patchValue({id_number: idNumber.substring(0,15)});
        this.form.get('id_number').markAsDirty();
        this.form.get('id_number').updateValueAndValidity();
        this.form.get('registration_number').markAsDirty();
        this.form.get('registration_number').updateValueAndValidity();
        return false;        
      }
    }  
    return true;
  }

  preValidateRegNumber(source: any) {  
    debugger;
    let registration_number: any;
    let sourceButton = source;

    if (source == 'captureRegNumber') {
      registration_number = this.form.get('registration_number').value;
    }

    if(registration_number=="" || registration_number=='' || registration_number==null){
      // exit on empty      
        this.form.get('registration_number').markAsDirty();
        this.form.get('registration_number').updateValueAndValidity();          
        return false; 
    }else if(registration_number.length > 20){
        // must be 20 or less chars in length
        this.form.get('registration_number').markAsDirty();
        this.form.get('registration_number').updateValueAndValidity();
        this.form.get('registration_number').setErrors({length:20}); 
        return false;
    }else if (sourceButton=="submit" && registration_number.length > 20){
      // onSubmit check
      this.msg.warning("Invalid Registration Number", "Carrier Account:");
      this.form.get('registration_number').markAsDirty();
      this.form.get('registration_number').updateValueAndValidity();
      return false; 
    }
    return true;
  }

  // validateID(control: FormControl) {
    // let id_number = control.value;    
  validateID(id: any) {    

    let id_number = id;
    let correct = true;

    if (id_number) {
      if(this.isLocal){
      }

      // SA ID Number have to be 13 digits, so check the length
      if (id_number.length != 13 || (!(!isNaN(parseFloat(id_number)) && isFinite(id_number)))/*!this.isNumber(id_number)*/) {
        //alert('A43');
        // this.showModal.showError('Oops', 'South African ID number must be 13 digits long. Please make sure you have selected the correct Nationality option.');
        this.msg.warning("ID Number must be numeric and not longer than 13 characters", "Carrier Account:");
        this.form.get('id_number').markAsDirty();
        correct = false;
        return;
      }

      // get first 6 digits as a valid date
      let tempDate = new Date(id_number.substring(0, 2), (id_number.substring(2, 4) - 1), id_number.substring(4, 6));

      let id_date = (tempDate.getDate().toString().length < 2) ? "0" + tempDate.getDate().toString() : tempDate.getDate().toString();
      let id_month = ((tempDate.getMonth() + 1).toString().length < 2) ? "0" + (tempDate.getMonth() + 1).toString() : (tempDate.getMonth() + 1).toString();
      let id_year = tempDate.getFullYear().toString().slice(-2);
      let dob = new Date(id_year + '/' + id_month + '/' + id_date);

      if (!((id_year == id_number.substring(0, 2).toString()) && (id_month == id_number.substring(2, 4).toString()) && (id_date == id_number.substring(4, 6).toString()))) {
        correct = false;
      }
    } else {
      correct = false;
      }

    if (id_number) {
      if (!correct) {
        return {
          saID: {
            saIdnumer: id_number
          }
        }
      }
    }
    return null;
  }

  addIDValidation = (type: number = 1) => {
    const idNumber = this.form.get('id_number');
    const idPartner = this.form.get('registration_number')
    const first_name = this.form.get('first_name');
    const last_name = this.form.get('last_name');
    //const id_type_ind= this.form.get('id_type_ind');
    let id_country_id = this.form.get('id_country_id');

    switch (type) {
      case 1:   // SA Individual
        //alert('Case 1');
        first_name.setValidators([Validators.required]);
        last_name.setValidators([Validators.required]);
        // idNumber.setValidators([this.validateID]);
        idNumber.setValidators([Validators.required , Validators.maxLength(13)]);
        //console.log('SA ID Number validation set');
        //id_type_ind.clearValidators();
        id_country_id.clearValidators();
        break;
      case 2:   // Foreign Individual
        //alert('Case 2');
        //first_name.setValidators([Validators.required]);
        //last_name.setValidators([Validators.required]);
        //idNumber.setValidators([Validators.required , Validators.maxLength(20)]);
        first_name.clearValidators();
        last_name.clearValidators();
        idNumber.clearValidators();
        
        //console.log('Foreign ID Number validation set');
        //id_type_ind.setValidators([Validators.required]);
        //id_country_id.setValidators([Validators.required]);
        break;
      case 8:   // Partnerships
      //alert('Case 8');
        idPartner.setValidators([Validators.required , Validators.maxLength(20)]);
        //console.log('Passport Number validation set');
        break;
      default:
        //alert('Case default');
        first_name.clearValidators();
        last_name.clearValidators();
        idNumber.clearValidators();
        idPartner.clearValidators();
        // id_type_ind.clearValidators();
        id_country_id.clearValidators();
        //console.log('SA ID Number validation unset');
        break;
    }

    last_name.updateValueAndValidity();
    first_name.updateValueAndValidity();
    idNumber.updateValueAndValidity();
    idPartner.updateValueAndValidity();
    //id_type_ind.updateValueAndValidity();
    id_country_id.updateValueAndValidity();
  }

  addRegisteredNameValidation = (type: number) => {
    const registered_name = this.form.get('registered_name');
    let registration_number = this.form.get('registration_number');
    switch (type) {
      case 1:
        //case 2:
        registered_name.clearValidators();
        registration_number.clearValidators();
        this.form.patchValue({ registered_name: null, trading_name: null, registration_number: null });
        break;
      default:
        registered_name.setValidators([Validators.required]);
        registration_number.setValidators([Validators.required]);
        break;
    }

    registered_name.updateValueAndValidity();
    registration_number.updateValueAndValidity();
  }

  getDOB = (id_number: any) => {
    if (!id_number) return null;
    let tempDate = new Date(id_number.substring(0, 2), (id_number.substring(2, 4) - 1), id_number.substring(4, 6));
    let id_date = (tempDate.getDate().toString().length < 2) ? "0" + tempDate.getDate().toString() : tempDate.getDate().toString();
    let id_month = ((tempDate.getMonth() + 1).toString().length < 2) ? "0" + (tempDate.getMonth() + 1).toString() : (tempDate.getMonth() + 1).toString();
    let id_year = tempDate.getFullYear().toString().slice(-2);
    let dob = new Date(id_year + '/' + id_month + '/' + id_date);
    return (!isNaN(dob.getTime())) ? dob : null;

  }

  //Contact details
  IsSameUser(event: any) {
    if (event.currentTarget.checked) {
      this.form.patchValue({
        Contact_FirstName: this.user.FirstName
        , Contact_LastName: this.user.LastName
        , Contact_EmailAddress: this.user.EmailAddress
        , Contact_MobileNumber: this.user.MobileNumber
      })
      this.defaultContactMobile = this.user.ISO2Mobile;
    } else {
      this.form.patchValue({
        Contact_FirstName: ''
        , Contact_LastName: ''
        , Contact_EmailAddress: ''
        , Contact_MobileNumber: ''
      })
      this.defaultContactMobile = '';
    }
  }

  listDDL = () => {
    this.transportAssocService.listTransportAssoc().subscribe(result => {
      this.listAssoc = result;
    }, error => {
      //console.log(error);
    });
  }

  constructCarrierObj = (obj: any) => {
    
    this.carrierStatus = obj.status_id;

    let carrierObj: any = {

      Carrier: {
          carrier_id: obj.carrier_id
        , carrier_type_id: obj.carrier_type_id
        , country_id: obj.country_id
        , registered_name: obj.registered_name
        , trading_name: obj.trading_name
        , registration_number: obj.registration_number
        , id_type_ind: this.id_type_required_ind
        , id_country_id: obj.id_country_id
        , id_number: obj.id_number
        , sameAsloggeIn: obj.sameAsloggeIn
        , role_served_ind: obj.role_served_ind
        , first_name: obj.first_name
        , last_name: obj.last_name
        , is_active_person: obj.is_active_person
        , date_of_birth: obj.date_of_birth
        , date_created: obj.date_created
        , date_modified: obj.date_modified
        , user_created: obj.user_created
        , user_modified: obj.user_modified
        , user_id: obj.user_id
        , status_id: obj.status_id
        , loggedInUser: obj.loggedInUser
        , bbbee_status: obj.bbbee_status
        , assoc_id: obj.assoc_id
        , communication_type: obj.Contact_CommunicationPreference
        , physical_address_1: obj.Contact_PhysicalAddress1
        , physical_address_2: obj.Contact_PhysicalAddress2
        , physical_address_3: obj.Contact_PhysicalAddress3
        , physical_address_town: obj.Contact_Town
        , physical_post_code: obj.Contact_PostalCode
        , physical_place_id: obj.Contact_CountryID
        , fax: obj.Contact_FaxNumber
        , email: obj.Contact_CompanyEmail
        , postal_address_1: obj.Contact_PostalAddress1
        , postal_address_2: obj.Contact_PostalAddress2
        , postal_address_3: obj.Contact_PostalAddress3
        , postal_address_town: obj.Contact_pTown
        , postal_post_code: obj.Contact_pPostalCode
        , postal_place_id: obj.Contact_pCountry
        , tax_number: obj.tax_number
        , traffic_register_number: obj.traffic_register_number
        , trn_issue_date: obj.trn_issue_date
        , work_permit_number: obj.work_permit_number
        , work_permit_expiry_date: obj.work_permit_expiry_date
        , passport_expiry_date: obj.passport_expiry_date
        // , business_type_ind: obj.business_type_id
        , freight_passenger_ind: obj.freight_passenger_ind
      },
      Contact: {
        PersonId: obj.PersonId
        , CarrierID: obj.Contact_CarrierID
        , is_active: obj.is_active_person
        , FirstName: obj.Contact_FirstName
        , LastName: obj.Contact_LastName
        , EmailAddress: obj.Contact_EmailAddress
        , CommunicationPreference: obj.Contact_CommunicationPreference
        , role_served_ind: (obj.Contact_role_served_ind > 0) ? obj.Contact_role_served_ind : 21
        , date_role_from: obj.Contact_date_role_from
        , date_role_to: obj.Contact_date_role_to
        , datecreated: obj.date_created
        , datemodified: obj.date_modified
        , usercreated: obj.user_created
        , usermodified: obj.user_modified
        , id_type_ind: obj.id_type_ind
      },
      Demographic: {
        carrier_id: obj.carrier_id
        , BBBEE: obj.bbbee_status
        , black_ownership_percentage: obj.black_ownership
        , female_ownership_percentage: obj.female_ownership
        , disability_ownership_percentage: obj.disability_ownership
        , youth_ownership_percentage: obj.youth_owner
        , turnover_band: obj.turnover_band
        , BBBEE_cert_expiry_date: obj.bbbee_certficate_date
        , number_of_employees: obj.num_employees
        , date_created: obj.date_created
        , date_modified: obj.date_modified
        , user_created: obj.user_created
        , user_modified: obj.user_modified
      }
    };

    if (obj.Contact_MobileNumber) {
      carrierObj.Contact.dial_code_cell = obj.Contact_MobileNumber.dialCode;
      carrierObj.Contact.MobileNumber = obj.Contact_MobileNumber.number;
      carrierObj.Contact.iso2_cell = this.defaultContactMobile;
    }

    if (obj.officePhone) {
      carrierObj.Carrier.dial_code_tele = obj.officePhone.dialCode;
      carrierObj.Carrier.telephone = obj.officePhone.number;
      carrierObj.Carrier.iso2_tele = this.defaultCarrierOfficePhone;
    }

    if (obj.cellphone) {
      carrierObj.Carrier.dial_code_cell = obj.cellphone.dialCode;
      carrierObj.Carrier.cellphone = obj.cellphone.number;
      carrierObj.Carrier.iso2_cell = this.defaultCarrierCellphone;
    }
    //console.log(carrierObj);
    return carrierObj;
  }

  copyTo = (event: any) => {
    if (event.currentTarget.checked) {
      this.form.patchValue({
        Contact_PostalAddress1: this.form.value.Contact_PhysicalAddress1,
        Contact_PostalAddress2: this.form.value.Contact_PhysicalAddress2,
        Contact_PostalAddress3: this.form.value.Contact_PhysicalAddress3,
        Contact_pTown: this.form.value.Contact_Town,
        Contact_pPostalCode: this.form.value.Contact_PostalCode,
        Contact_pCountry: this.form.value.Contact_CountryID,
      });
      return;
    }
    this.form.patchValue({
      Contact_PostalAddress1: '',
      Contact_PostalAddress2: '',
      Contact_PostalAddress3: '',
      Contact_pTown: '',
      Contact_pPostalCode: '',
      Contact_pCountry: '',
    });
  }

  onItemChange = () => {
    // this.changeBasicContactInfoParm();
    let assoc = this.form.get("assoc_id").value;
    this.trspassoc = (assoc != "") ? "None" : "None";
  }

  onFrmChange = () => {
    this.form.valueChanges.subscribe(selectedValue => {
      this.utility.isChanged = this.isModified();
    })
  }

  isModified = () => {
    return ((JSON.stringify(this.form.value) !== JSON.stringify(this.originalAccount.account)) && this.form.dirty);
  }

  transient = (obj: any) => {
    this.originalAccount.account = obj.value;
  }

  autoSave = (key: number) => {
    this.onSubmit(this.form.value, key);
  }

  selectCommunication(communication) {
    if (communication.value == 'Email') {
      this.form.get('Contact_EmailAddress').setValidators(Validators.compose([Validators.required, Validators.pattern(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/)]));
      this.form.get('Contact_EmailAddress').markAsTouched();
      this.form.get('Contact_EmailAddress').markAsDirty();
      this.form.get('Contact_MobileNumber').clearValidators();
    } else {
      this.form.get('Contact_MobileNumber').setValidators([Validators.required]);
      this.form.get('Contact_MobileNumber').markAsTouched();
      this.form.get('Contact_MobileNumber').markAsDirty();
      this.form.get('Contact_EmailAddress').clearValidators();
    }
    this.form.get('Contact_EmailAddress').updateValueAndValidity();
    this.form.get('Contact_MobileNumber').updateValueAndValidity();
  }

  onChange(eventType): void {
    // this.changeBasicContactInfoParm();
    const carType = this.ddlCarrierTypes.find(type => type.id == this.carrierType);
    this.removeSouthAfrica(carType);

    if (carType) {
      this.is_individual = carType.is_individual;
      this.idType = carType.id_type_required_ind;
      this.id_type_required_ind = carType.id_type_required_ind;
      this.is_local_carrier = carType.is_local_carrier;
      this.isForeignId = (this.id_type_required_ind == 2) ? true : false;
      this.displayDemographics = carType.display_demog_frame;
      this.form.patchValue({ 'id_type_ind': this.id_type_required_ind });
      this.onSetIdLabel(this.id_type_required_ind);
      //console.log('Id_type_required_ind =', this.id_type_required_ind);
      // this.hasBusinessType();
    }
    this.whichCarrierType = (this.is_individual) ?  1: 2;

    if (!this.isEdit && !this.aCarrier.Carrier) {
      this.form.patchValue({ country_id: '', Contact_pCountry: '', Contact_CountryID: '', registered_name: null, trading_name: null, registration_number: null, id_type_ind: 0, id_country_id: null, id_number: null, sameAsloggeIn: false, first_name: null, last_name: null });
      this.form.markAsPristine();
    }

    if (this.is_local_carrier && !this.isEdit) {
      let key:any = 0;
      // this.ddlCountries.sort();
      if(this.ddlCountries.find(ctry => ctry.code == "ZA")){
        key = this.ddlCountries.find(ctry => ctry.code == "ZA").id;
        if(key!=0){
          this.form.patchValue({ 'country_id': key });
          this.form.patchValue({ 'Contact_pCountry': key });
          this.form.patchValue({ 'Contact_CountryID': key });
        }
      }
    }

    this.addIDValidation(this.idType);
    this.addRegisteredNameValidation(this.whichCarrierType);

      if (eventType == 'change') {
          //refresh dynamic fields
          if (this.form.get('officePhone')) {
              //this.form.get('officePhone').setValue(this.aCarrier.Carrier.telephone);
          }
          if (this.form.get('cellphone')) {
              //this.form.get('cellphone').setValue(this.aCarrier.Carrier.cellphone);
          }


      this.form.get('sameAsloggeIn').setValue(false);
      setTimeout(() => {
        if (this.id_type_required_ind == 2) {
          const idNumber = this.form.get('id_number');
          idNumber.setValue('');
          this.addIDValidation(2);
        }
      }, 300)
    }

    this.validateTaxFrame();
    this.validateDemographicFrame(this.displayDemographics);
    this.setPassportValidation(this.isForeignId);   
  }

  setPassportValidation(isIdForeign)
  {
    let PASSPORT_expiry_date = this.form.get('passport_expiry_date');

    if(isIdForeign)
    {
      PASSPORT_expiry_date.setValidators([Validators.required]);
    }
    else{
      PASSPORT_expiry_date.clearValidators();
    }
    PASSPORT_expiry_date.updateValueAndValidity();
  }

  removeSouthAfrica(type){
    if(type.desc.includes('Foreign')){
        this.ddlCountries = this.ddlCountries.filter(x => x.id !== 113);;
    }else{
      this.listCountries();
    }
  }

  onSetIdLabel = (id_ind = 0) => {
    this.id_label = this.idTypes.find(type => type.key == id_ind).value;
  }

  numbersOnly(event): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }

  onPhysicalAddressChange(physicalAddressInput) {
    if (physicalAddressInput.value.length > 1) {
      this.googleSearch.searchPlace(physicalAddressInput.value).subscribe((data:any) => {
        this.placesPredictions = data.predictions;
        if (this.placesPredictions.length > 0)
          this.isPlacesPredictionVible = true;
      });
    }
    else {
      this.isPlacesPredictionVible = false;
    }
  }

  clickSearchedPlace(place) {
    this.populateAddressInputs(place, true);
    this.isPlacesPredictionVible = false;
  }

  physicalAddressFocus() {
    if (this.placesPredictions.length > 0)
      this.isPlacesPredictionVible = true;
  }

  physicalAddressBlur() {
    setTimeout(() => {
      this.isPlacesPredictionVible = false;
    }, 300);
  }

  onPostalAddressChange(postalAddressInput) {
    if (postalAddressInput.value.length > 1) {
      this.googleSearch.searchPlace(postalAddressInput.value).subscribe((data:any) => {
        this.placesPostalPredictions = data.predictions;
        if (this.placesPostalPredictions.length > 0)
          this.isPostalPlacesPredictionVible = true;
      });
    }
    else {
      this.isPostalPlacesPredictionVible = false;
    }
  }

  clickSearchedPlacePostal(place) {
    this.populateAddressInputs(place, false);
    this.isPostalPlacesPredictionVible = false;
  }

  postalAddressFocus() {
    if (this.placesPostalPredictions.length > 0)
      this.isPostalPlacesPredictionVible = true;
  }

  postalAddressBlur() {
    setTimeout(() => {
      this.isPostalPlacesPredictionVible = false;
    }, 300);
  }

  populateAddressInputs(place, isPhysical) {
    this.googleSearch.searchPlaceDetails(place.place_id).subscribe((data:any) => {
      let addressLine_comps = "";
      let addressLine_1 = data.result.address_components.find(c => c.types.indexOf('street_number') > -1);
      if (addressLine_1 != undefined)
        addressLine_comps = addressLine_1.long_name;
      let addressLine_2 = data.result.address_components.find(c => c.types.indexOf('route') > -1);
      if (addressLine_comps == "" && addressLine_2 != undefined)
        if (addressLine_comps != addressLine_2.long_name)
          addressLine_comps = addressLine_2.long_name;
      if (addressLine_comps != "" && addressLine_2 != undefined)
        if (addressLine_comps != addressLine_2.long_name)
          addressLine_comps = addressLine_comps + " " + addressLine_2.long_name;;

      let townStr = "";
      let locality = data.result.address_components.find(c => c.types.indexOf('sublocality_level_1') > -1 || c.types.indexOf('sublocality') > -1 || c.types.indexOf('locality') > -1);
      if (locality != undefined)
        townStr = locality.long_name;

      let postalStr = "";
      let postalCode = data.result.address_components.find(c => c.types.indexOf('postal_code') > -1);
      if (postalCode != undefined)
        postalStr = postalCode.long_name;

      let countryIdInt = "";
      let country = data.result.address_components.find(c => c.types.indexOf('country') > -1);
      if (country != undefined) {
        let dbCountry = this.ddlCountries.find(c => c.desc.toLowerCase() == country.long_name.toLowerCase() || c.code.toLowerCase() == country.short_name.toLowerCase());
        if (dbCountry != undefined) {
          countryIdInt = dbCountry.id;
        }
      }
      if (isPhysical)
        this.form.patchValue({
          Contact_PhysicalAddress1: addressLine_comps
          , Contact_Town: townStr
          , Contact_PostalCode: postalStr
          , Contact_CountryID: countryIdInt
        });
      if (!isPhysical)
        this.form.patchValue({
          Contact_PostalAddress1: addressLine_comps
          , Contact_pTown: townStr
          , Contact_pPostalCode: postalStr
          , Contact_pCountry: countryIdInt
        });
    });
  }

  // hasBusinessType = () => {
  //   const keys = [1, 2, 5];
  //   let hasKey = (keys.find(key => {
  //     return key == this.id_type_required_ind;
  //   })) ? true : false;
  //   if (hasKey) {
  //     this.form.patchValue({ 'business_type_id': 21 });
  //   }
  //   return hasKey;
  // }

  //alert("1!");
  // validateFields(flag){
  //   // mandatory fields are controlled by 'Validators.required' in initForm()
  //   if (this.form.value.carrier_type_id == 0){
  //     //alert('B2');
  //       // this.msg.warning("Customer Type is required", "Carrier Account:");
  //       // let fieldName:any=this.errorField[this.carrier_type_id];
  //       // this.msg.warning(fieldName, "Carrier Account:");
  //       // this.form.controls.carrier_type_id.markAsDirty();
  //       // return false;
  //       const control = this.form.get("carrier_type_id");
  //       control.markAsTouched({ onlySelf: true });
  //       let fieldName:any=this.errorField["carrier_type_id"];
  //         this.msg.warning(fieldName, "Carrier Account:");
  //         control.markAsDirty();
  //         return false;    
  //   }
//
    // let comFlag:boolean=flag;
    // Object.keys(this.form.controls).forEach(field => { // {1}
    //   const control = this.form.get(field);            // {2}
    //   control.markAsTouched({ onlySelf: true });       // {3}
    //   //console.log('-------'+field);
    //   if(control.invalid && !comFlag){
    //     alert('B1');
    //     let fieldName:any=this.errorField[field];
    //     this.msg.warning(fieldName, "Carrier Account:");
    //     control.markAsDirty();
    //     comFlag=true;
    //     return false;
    //   }else{
    //   }
    //});
    //return true;
  //}

  validateTaxFrame(){
    let tax_no = this.form.get('tax_number');
    if(this.is_local_carrier){
      if(this.carrierType===1011 || this.carrierType===1007 || this.carrierType===1017){ // carrier type "Other | Partnership - Foreign" -> display Tax Number, but no validations required
        //alert(this.carrierType);

        tax_no.clearValidators();
      } else { // display and validate
        tax_no.setValidators([Validators.required]);
      }
    } else {
      tax_no.clearValidators();
    }
    tax_no.updateValueAndValidity();
  }

  // isShowDemographicFrame(typeId) {
  //   const cType = this.ddlCarrierTypes.find(type => type.id == typeId);
  //   if (cType) {
  //     let status = (cType.display_demog_frame && cType.is_local_carrier);
  //     this.addDemographicValidations(status);
  //     return true;
  //   }
  //   return true;
  // }

  validateDemographicFrame(display: boolean) {
      if(this.carrierType===1011){ // carrier type "Other" -> display Demographics, but enforce no validations
        this.addDemographicValidations(false);
        return true;
      } else { // display and validate according to DB value
        this.addDemographicValidations(display);
        return true;
      }
  }

   addDemographicValidations = (isLocal) => {
    this.isLocal = isLocal;
    let BBBEE = this.form.get('bbbee_status');
    let black_ownership_percentage = this.form.get('black_ownership');
    let female_ownership_percentage = this.form.get('female_ownership');
    let disability_ownership_percentage = this.form.get('disability_ownership');
    let youth_ownership_percentage = this.form.get('youth_owner');
    let turnover_band = this.form.get('turnover_band');
    let BBBEE_cert_expiry_date = this.form.get('bbbee_certficate_date');
    let number_of_employees = this.form.get('num_employees');

    if (isLocal && this.form.value['bbbee_status']!='NonCompliant') {
      BBBEE.setValidators([Validators.required]);
      BBBEE_cert_expiry_date.setValidators([Validators.required]);
      black_ownership_percentage.setValidators([Validators.required]);
      female_ownership_percentage.setValidators([Validators.required]);
      disability_ownership_percentage.setValidators([Validators.required]);
      youth_ownership_percentage.setValidators([Validators.required]);
      turnover_band.setValidators([Validators.required]);
      number_of_employees.setValidators([Validators.required]);
    } else {
      BBBEE.clearValidators();
      BBBEE_cert_expiry_date.clearValidators();
      black_ownership_percentage.clearValidators();
      female_ownership_percentage.clearValidators();
      disability_ownership_percentage.clearValidators();
      youth_ownership_percentage.clearValidators();
      turnover_band.clearValidators();
      number_of_employees.clearValidators();
    }

    BBBEE.updateValueAndValidity();
    BBBEE_cert_expiry_date.updateValueAndValidity();
    black_ownership_percentage.updateValueAndValidity();
    female_ownership_percentage.updateValueAndValidity();
    disability_ownership_percentage.updateValueAndValidity();
    youth_ownership_percentage.updateValueAndValidity();
    turnover_band.updateValueAndValidity();
    number_of_employees.updateValueAndValidity();
  }

  changeBBEE(bbeeStatus){

    this.changeBasicContactInfoParm();

    let BBBEE_cert_expiry_date = this.form.get('bbbee_certficate_date');
    let black_ownership_percentage = this.form.get('black_ownership');
    let female_ownership_percentage = this.form.get('female_ownership');
    let disability_ownership_percentage = this.form.get('disability_ownership');
    let youth_ownership_percentage = this.form.get('youth_owner');
    let turnover_band = this.form.get('turnover_band');
    let number_of_employees = this.form.get('num_employees');

    if(!this.is_local_carrier ||
      this.carrierType===1011 ||
      this.form.value['bbbee_status']=='NonCompliant')
      {
        BBBEE_cert_expiry_date.clearValidators();
        black_ownership_percentage.clearValidators();
        female_ownership_percentage.clearValidators();
        disability_ownership_percentage.clearValidators();
        youth_ownership_percentage.clearValidators();
        turnover_band.clearValidators();
        number_of_employees.clearValidators();
      }

      BBBEE_cert_expiry_date.updateValueAndValidity();
      black_ownership_percentage.updateValueAndValidity();
      female_ownership_percentage.updateValueAndValidity();
      disability_ownership_percentage.updateValueAndValidity();
      youth_ownership_percentage.updateValueAndValidity();
      turnover_band.updateValueAndValidity();
      number_of_employees.updateValueAndValidity();
  }

  resetForm(){
  // this.form.patchValue({
  //       country_id: ''
  //     , registered_name: null
  //     , trading_name: null
  //     , registration_number: null
  //     , id_type_ind: 0
  //     , id_country_id: null
  //     , id_number: null
  //     , sameAsloggeIn: false
  //     , first_name: null
  //     , last_name: null

  //     // Contact Details
  //     , Contact_is_active: null
  //     , Contact_FirstName: ''
  //     , Contact_LastName: ''
  //     , Contact_EmailAddress: ''
  //     , Contact_MobileNumber: ''
  //     , Contact_CommunicationPreference: ''
  //     , Contact_PhysicalAddress1: ''
  //     , Contact_PhysicalAddress2:''
  //     , Contact_PhysicalAddress3: ''
  //     , Contact_Town: ''
  //     , Contact_PostalCode: ''
  //     , Contact_CountryID: ''
  //     , Contact_FaxNumber: ''
  //     , Contact_CompanyEmail: ''
  //     , Contact_PostalAddress1: ''
  //     , Contact_PostalAddress2: ''
  //     , Contact_PostalAddress3: ''
  //     , Contact_pTown:''
  //     , Contact_pPostalCode: ''

  //     //Demographics
  //     , black_ownership: ''
  //     , female_ownership: ''
  //     , disability_ownership: ''
  //     , youth_owner:''
  //     , turnover_band: ''
  //     , bbbee_certficate_date: ''
  //     , num_employees: ''
  //   });
    this.initFormData();
    this.setFormData();
    this.isBasicContactInfo = true;
    this.form.markAsPristine();
}
}

